import { LazySPItemsViewCommandBar } from './spDocLibView';

import { observer } from 'mobx-react';
import * as React from 'react';

@observer
export default class FilesHubCommandBar extends React.Component {
    render(): JSX.Element {
        return <LazySPItemsViewCommandBar />;
    }
}
